<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form ref="formValidate" :model="formValidate" :label-width="110">
        <Row>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商编号:" prop="agentId">
              <Input v-model.trim="formValidate.agentId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商名称:" prop="agentName">
              <Input v-model.trim="formValidate.agentName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商订单号:" prop="outTradeNo">
              <Input v-model.trim="formValidate.outTradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="平台订单号:" prop="tradeNo">
              <Input v-model.trim="formValidate.tradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="平台商品编号:" prop="commodityId">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="供应商商品编号:" prop="commodityNo">
              <Input v-model.trim="formValidate.commodityNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品名称:" prop="commodityName">
              <Input v-model.trim="formValidate.commodityName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="购买方式:" prop="rechargeType">
              <Select v-model="formValidate.rechargeType" clearable style="width: 100%;">
                <Option v-for="item in rechargeTypeCarmi" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="开始时间:" prop="startDate">
              <DatePicker type="datetime" v-model="formValidate.startDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="结束时间:" prop="endDate">
              <DatePicker type="datetime" v-model="formValidate.endDate" placeholder="请选择" style="width:100%" />
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col :md='24' style="margin-bottom: 20px">
          <Button
            type="info"
            icon="md-download"
            style="margin-right: 8px"
            :disabled="!queryData.length"
            @click="exportOrder"
          >导出</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="rechargeType">
          <span>{{ getRechargeLabel(row.rechargeType) }}</span>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <ExportFile ref="exportFile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import utils from '../../utils'
import ExportFile from '../../components/common/ExportFile'

export default {
  components: {
    ExportFile
  },
  data () {
    return {
      formValidate: {
        agentId: null,
        agentName: null,
        outTradeNo: null,
        tradeNo: null,
        commodityId: null,
        commodityNo: null,
        commodityName: null,
        rechargeType: null,
        startDate: null,
        endDate: null
      },
      queryData: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1
    }
  },
  computed: {
    startDate () {
      return this.formValidate.startDate ? this.formValidate.startDate.getTime() : null
    },
    endDate () {
      return this.formValidate.endDate ? this.formValidate.endDate.getTime() : null
    },
    startDateText () {
      return this.startDate ? utils.formatDateTime(this.startDate) : null
    },
    endDateText () {
      return this.endDate ? utils.formatDateTime(this.endDate) : null
    },
    ...mapGetters('recharge', ['rechargeTypeCarmi', 'rechargeMethodCarmiByValue']),
    queryColumn () {
      return [
        {
          title: '平台订单号',
          key: 'tradeNo',
          minWidth: 150
        },
        {
          title: '代理商订单号',
          key: 'outTradeNo',
          minWidth: 150
        },
        {
          title: '代理商名称',
          key: 'agentName',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'commodityName',
          minWidth: 150
        },
        {
          title: '商品编号',
          key: 'commodityId',
          minWidth: 150
        },
        {
          title: '供应商商品编号',
          key: 'commodityNo',
          minWidth: 150
        },
        {
          title: '商品票面价格',
          key: 'facePrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '卡号',
          key: 'cardNo',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '购买方式',
          key: 'rechargeType',
          minWidth: 150,
          align: 'center',
          slot: 'rechargeType'
        },
        {
          title: '过期时间',
          key: 'expireDate',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createDate',
          minWidth: 190,
          render: (h, params) => {
            return h('span', utils.formatDateTime(params.row.createDate))
          }
        }
      ]
    }
  },
  methods: {
    formSubmit () {
      // 判断开始时间和结束时间
      if (this.startDate && this.endDate && (this.startDate >= this.endDate)) {
        this.$Message.error('开始时间不能大于或等于结束时间！')
        return
      } else if (this.startDate && !this.endDate) {
        this.$Message.error('请选择结束时间！')
        return
      } else if (!this.startDate && this.endDate) {
        this.$Message.error('请选择开始时间！')
        return
      }
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.formSubmit()
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== '' && element !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      if (this.startDate) {
        params.startDate = this.startDate
      }
      if (this.endDate) {
        params.endDate = this.endDate
      }
      api.order.carmiList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    // 导出
    exportOrder () {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            if (item === 'startDate' || item === 'endDate') {
              params[item] = new Date(this.formValidate[item]).getTime()
            } else {
              params[item] = this.formValidate[item]
            }
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = 100
      this.$refs.exportFile.submit(api.order.carmiOutQueryOrder, 'get', {
        ...params
      })
    },
    // 手动购买
    manualBuy () {
      this.$refs.manualBuy.show()
    },
    // 购买成功
    buySuccess () {
      this.getData()
    },
    // 购买方式
    getRechargeLabel (value) {
      const item = this.rechargeMethodCarmiByValue(value)
      return item ? item.label : ''
    }
  },
  created () {
    this.getData()
  }
}
</script>
